import { Controller } from "@hotwired/stimulus"
import { MAIN_NAVIGATION_OPEN_BODY_CLASS } from "./main_navigation_controller"

// Connects to data-controller="swipe-navigation"
// Recreates a left-edge swipe-to-go-back gesture for the mobile app's
// WebView, where native swipe gestures are disabled.
export default class extends Controller {
  static values = {
    edgeWidth: { type: Number, default: 24 },
    threshold: { type: Number, default: 80 },
  }

  connect() {
    this.onTouchStart = this.onTouchStart.bind(this)
    this.onTouchMove = this.onTouchMove.bind(this)
    this.onTouchEnd = this.onTouchEnd.bind(this)
    this.onMessage = this.onMessage.bind(this)

    document.addEventListener("touchstart", this.onTouchStart, { passive: true })
    document.addEventListener("touchmove", this.onTouchMove, { passive: false })
    document.addEventListener("touchend", this.onTouchEnd)
    document.addEventListener("touchcancel", this.onTouchEnd)

    // Android WebView's postMessage surfaces as a "message" event on document.
    document.addEventListener("message", this.onMessage)
  }

  disconnect() {
    document.removeEventListener("touchstart", this.onTouchStart)
    document.removeEventListener("touchmove", this.onTouchMove)
    document.removeEventListener("touchend", this.onTouchEnd)
    document.removeEventListener("touchcancel", this.onTouchEnd)
    document.removeEventListener("message", this.onMessage)
  }

  onMessage(event) {
    let data

    try {
      data = JSON.parse(event.data)
    } catch {
      return
    }

    if (data?.type !== "ANDROID_BACK_ACTION") return

    const handled = this.handleSwipeComplete()
    if (!handled) window.ReactNativeWebView?.postMessage(JSON.stringify({ type: "ANDROID_BACK_ACTION_NOOP" }))
  }

  onTouchStart(event) {
    const touch = event.touches[0]

    if (touch.clientX > this.edgeWidthValue) {
      this.tracking = false
      return
    }

    this.tracking = true
    this.cancelled = false
    this.horizontalIntentConfirmed = false
    this.startX = touch.clientX
    this.startY = touch.clientY
  }

  onTouchMove(event) {
    if (!this.tracking || this.cancelled) return

    const touch = event.touches[0]
    const deltaX = touch.clientX - this.startX
    const deltaY = touch.clientY - this.startY

    if (!this.horizontalIntentConfirmed) {
      if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        this.cancelled = true
        return
      }

      this.horizontalIntentConfirmed = true
    }

    if (deltaX > 0) event.preventDefault()
  }

  onTouchEnd(event) {
    if (!this.tracking || this.cancelled) {
      this.tracking = false
      return
    }

    const touch = event.changedTouches[0]
    const deltaX = touch.clientX - this.startX

    this.tracking = false

    if (deltaX >= this.thresholdValue) this.handleSwipeComplete()
  }

  handleSwipeComplete() {
    if (document.body.classList.contains("modal-is-open")) {
      document.dispatchEvent(new CustomEvent("swipe-back:close-modal"))
      return true
    }

    const backBtn = document.getElementById("btn-back")
    if (backBtn) {
      backBtn.click()
      return true
    }

    if (document.body.classList.contains(MAIN_NAVIGATION_OPEN_BODY_CLASS)) return false

    const openBtn = document.getElementById("openNavigationBtn")
    if (!openBtn) return false

    openBtn.click()
    return true
  }
}
